import React, {useState, useEffect} from 'react';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {HeadGraficas} from './HeadGraficas';
import Dropdown from 'react-dropdown';
import Chart from 'chart.js/auto';
import 'react-dropdown/style.css';
import {useMemo} from 'react';

import {Line} from 'react-chartjs-2';
import {Bar} from 'react-chartjs-2';
import {Pie} from 'react-chartjs-2';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
} from 'chart.js';

export const ContentBodyGraficas = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* A hook that is used to set the state of the component. */
	const [nombreGrafica, setnombreGrafica] = useState('line');

	/**
	 * A function that changes the name of the graph.
	 */
	const cambiarNombreGrafica = (event) => {
		setnombreGrafica(event.target.value);
	};
	const scores = [2, 5, 5, 5, 3, 4, 6, 4, 5];
	const scores2 = [1, 3, 5, 9, 14, 13, 12, 11, 12];
	const labels = [100, 200, 300, 400, 500, 600, 700];

	return (
		<>
			<MenuLateralAB
				seleccionado={6}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentUserFeedback'>
				<div className='derContentUserFeedback marginGraficas'>
					<HeadGraficas
						nombreGrafica={nombreGrafica}
						cambiarNombreGrafica={cambiarNombreGrafica}
					/>
					<div className='contGraficas centrador'>
						<div className='centrador'>
							<div className='tituloGrafica centrador'> Grafica 1</div>
							<Line
								data={{
									datasets: [
										{
											label: ['datos1'],
											data: scores,
											tension: 0.4,
										},
										{
											label: ['datos2'],
											data: scores2,
											tension: 0.4,
										},
									],
									labels,
								}}
								options={{
									responsive: true,
									scales: {
										y: {
											min: 0,
										},
									},
									borderColor: ['rgb(255, 99, 132)', 'rgb(53, 162, 235)'],
									backgroundColor: [
										'rgba(255, 99, 132, 0.5)',
										'rgba(53, 162, 235, 0.5)',
									],
								}}
							/>
						</div>
						<div className='centrador'>
							<div className='tituloGrafica centrador'> Grafica 2</div>
							<Bar
								data={{
									datasets: [
										{
											label: ['datos1'],
											data: scores,
											tension: 0.4,
										},
										{
											label: ['datos2'],
											data: scores2,
											tension: 0.4,
										},
									],
									labels,
								}}
								options={{
									responsive: true,
									scales: {
										y: {
											min: 0,
										},
									},
									borderColor: ['rgb(255, 99, 132)', 'rgb(53, 162, 235)'],
									backgroundColor: [
										'rgba(255, 99, 132, 0.5)',
										'rgba(53, 162, 235, 0.5)',
									],
								}}
							/>
						</div>
						<div className='centrador'>
							<div className='tituloGrafica centrador'> Grafica 3</div>
							<Pie
								data={{
									datasets: [
										{
											label: ['datos1'],
											data: scores,
											tension: 0.4,
										},
										{
											label: ['datos2'],
											data: scores2,
											tension: 0.4,
										},
									],
									labels,
								}}
								options={{
									responsive: true,
									scales: {
										y: {
											min: 0,
										},
									},
									borderColor: ['rgb(255, 99, 132)', 'rgb(53, 162, 235)'],
									backgroundColor: [
										'rgba(255, 99, 132, 0.5)',
										'rgba(53, 162, 235, 0.5)',
									],
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
